import React, { useMemo } from 'react';

import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector } from 'flow/hooks/useRedux';
import { getSearchText } from 'flow/selectors/selectors';
import NoMatchOnSearch from '../empty-states/NoMatchOnSearch';
import ChatSessionsListView from './ChatSessionsListView';
import useChatSessionRows from './useChatSessionRows';
import useNewChatRows from './useNewChatRows';

/** The chat list while searching: the same chat sessions, narrowed to what
 *  matches, followed by the colleagues there is no chat with yet. */
const ChatSessionsSearchList = () => {
    const { i18next } = useAppContext();
    const searchText = useAppSelector(getSearchText);

    const chatSessions = useChatSessionRows();
    const newChatRows = useNewChatRows();
    const rows = useMemo(
        () => [...chatSessions.rows, ...newChatRows],
        [chatSessions.rows, newChatRows],
    );

    // The fixed entries at the top are narrowed by the search too.
    const nothingMatched = !rows.length;

    return (
        <ChatSessionsListView
            rows={rows}
            emptyState={
                nothingMatched ? (
                    <NoMatchOnSearch reserveScrollbarGutter={true}>
                        {i18next.t('general.search.no-results', {
                            search: searchText,
                        })}
                    </NoMatchOnSearch>
                ) : undefined
            }
        />
    );
};

export default ChatSessionsSearchList;
